// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xjvz","title":"Header_title__2Qbph","side":"Header_side__2HZvg"};